
import request from "@/utils/request";

/**
 * 查询会员统计
 * @returns {AxiosPromise}
 */
export function getUsersStatis() {
  return request({
    url: "/home/getUserStatistics",
    method: "get",
    params: {}
  });
}

/**
 * 查询订单统计
 * @returns {AxiosPromise}
 */
export function getOrderStatis() {
  return request({
    // url: "/report/getOrderStatis",
    url:"/home/getOrderStatistics",
    method: "get",
    params: {}
  });
}

/**
 * 查询余额统计
 * @returns {AxiosPromise}
 */
export function getBalanceStatis() {
  return request({
    url: "/home/getBalanceStatis",
    method: "get",
    params: {}
  });
}

export function getSalesStatistics(data = {}) {
  return request({
    url: "/home/getSalesStatistics",
    method: "get",
    params: data
  });
}

export function getDataSummary(data = {}) {
  return request({
    url: "/home/getDataSummary",
    method: "get",
    params: data
  });
}

export function getAcctFlow(data = {}) {
  return request({
    url: "/home/getAcctFlow",
    method: "get",
    params: data
  });
}

export function getAddOrderList(data = {}) {
  return request({
    url: "/home/getAddOrderList",
    method: "get",
    params: data
  });
}

export function getPendingAfterOrderList(data = {}) {
  return request({
    url: "/home/getPendingAfterOrderList",
    method: "get",
    params: data
  });
}

export function getNewAddUserList(data = {}) {
  return request({
    url: "/home/getNewAddUserList",
    method: "get",
    params: data
  });
}

export function getExpendTop10(data = {}) {
  return request({
    url: "/home/getExpendTop10",
    method: "get",
    params: data
  });
}
